import { FileAttachmentData } from '../../../../../../../types';

export const selectPreviewLink = (attachment: FileAttachmentData) =>
    attachment?.coverImageUrl ||
    attachment?.preview_urls?.thumb_large ||
    Object.keys(attachment?.preview_urls || {})[0];
export const isFileLoaded = (attachment: FileAttachmentData) =>
    selectPreviewLink(attachment) || attachment.loaded || Number.isNaN(Number(attachment.progress));
